import { render, staticRenderFns } from "./FilterPanel.vue?vue&type=template&id=0bd999ad&"
import script from "./FilterPanel.vue?vue&type=script&lang=ts&"
export * from "./FilterPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FilterPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterElement: require('E:/Jenkins/workspace/PowerBi-Dashboard VisserijDashboard (WECR)/Presentatie/src/components/FilterElement.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VList,VListItem,VSpacer,VToolbar,VToolbarTitle})
